export var AuthScopeFailureType;
(function (AuthScopeFailureType) {
    AuthScopeFailureType["AuthScope"] = "AuthScope";
    AuthScopeFailureType["AuthScopeFunction"] = "AuthScopeFunction";
    AuthScopeFailureType["GrantedScope"] = "GrantedScope";
    AuthScopeFailureType["AnyAuthScopes"] = "AnyAuthScopes";
    AuthScopeFailureType["AllAuthScopes"] = "AllAuthScopes";
    AuthScopeFailureType["Unknown"] = "Unknown";
})(AuthScopeFailureType || (AuthScopeFailureType = {}));
//# sourceMappingURL=types.js.map
